<template>
    <v-row class='justify-center'>
        <v-col lg=3 md=12>
            <v-card min-height='300' class='pa-8'>
                <v-card-title>Signup</v-card-title>
                <v-form class='pb-3' ref="form">
                    <v-text-field :rules="[rules.required]" outlined v-model="name" dense label='Name' name='name'></v-text-field>
                    <v-text-field :rules="[rules.required]" outlined v-model="email" dense label='Email'></v-text-field>
                    <v-text-field :rules="[rules.required]" outlined v-model="phone" dense label='Phone'></v-text-field>
                    <v-text-field :rules="[rules.required]" outlined v-model="password" dense type='password' label='Password'></v-text-field>
                    <v-text-field :rules="[rules.required]" outlined v-model="confirm_password" dense type='password' label='Confirm Password'></v-text-field>
                    <v-btn @click="userSignup" color='primary'>Signup</v-btn>
                </v-form>

                <p class='text-center'>Already Signed up?</p>
                <a @click="login"><p class='text-center'>Login</p></a>
            </v-card>
        </v-col>
    </v-row>
  
</template>
<script>
/*global myBaseURL*/

import axios from 'axios';

export default {
    name: 'Signup',
    data() {
        return {
            name: '',
            email: '',
            phone : '',
            password: '',
            confirm_password: '',
            rules:{
                required: value => !!value || 'Required.',
                counter: value => value.length <= 25 || 'Max 25 characters',
            },
        }
    },
    methods : ({
        login(){
            this.$router.push({ path: '/' + this.$route.params.store_slug + '/login' })
        },
        userSignup(){
            if(this.$refs.form.validate())
            {
                if(this.password == this.confirm_password)
                {
                    var that = this;
                    axios.request({
                        url: '/customer/registration',
                        method: 'POST',
                        baseURL: myBaseURL,
                        data : {
                            name : that.name,
                            email : that.email,
                            phone : that.phone,
                            password : that.password,
                            store_slug : that.$route.params.store_slug
                        }
                    }).then(response => {
                        console.log(response.data.access_token);
                        localStorage.setItem('access_token', response.data['access_token']);
                        that.$router.push({ path: '/' + this.$route.params.store_slug + '/addDetails' });
                        console.log('Submit Success')
                    }).catch(e => {
                        console.log(e);
                        console.log('Submit Fail')
                    });
                    console.log('done');
                }
                else
                {
                    console.log('Both passwords do not match.');
                }
            }
        }
    })
}
</script>